export default "__VITE_ASSET__bx2F1UZ5__"